import { useEffect } from 'react';
import MESSAGE_TYPES from '../constants/MESSAGE_TYPES';

const useModal = ({ onClickOverlay }) => {
  const stopPropagation = (event) => event.stopPropagation();
  const onMessageReceived = (event) => {
    if (event.data.type === MESSAGE_TYPES.EXIT_FULLSCREEN) onClickOverlay();
  };

  useEffect(() => {
    window.addEventListener('message', onMessageReceived, false);
    return () => { setTimeout(() => window.removeEventListener('message', onMessageReceived, false), 300); }
  }, []);

  return { stopPropagation };
};

export default useModal;
